import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'item-group',
  templateUrl: './item-group.component.html',
  styleUrls: ['./item-group.component.scss']
})
export class ItemGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
